/**
 * Local layout debugging for GasPump.vue — no backend or pump hardware required.
 *
 * Enable (dev only):
 *   ?gasPumpDebug=1  on the shop URL, or
 *   localStorage.setItem('gasPumpDebug', '1')  then reload
 *
 * Disable:
 *   localStorage.removeItem('gasPumpDebug')
 *
 * Pump status codes (edit pStat below to preview each CSS class):
 *   0 = Available (green)     .pump-status-0
 *   1 = Nozzle out / AUTO     .pump-status-1
 *   3 = Filling               .pump-status-3
 *   5 = Approved              .pump-status-5
 *   8, 9 = Error              .pump-status-8 / .pump-status-9
 */

export function isGasPumpDebugEnabled () {
  if (!process.dev) {
    return false
  }
  if (typeof window === 'undefined') {
    return false
  }
  if (new URLSearchParams(window.location.search).get('gasPumpDebug') === '1') {
    return true
  }
  return window.localStorage.getItem('gasPumpDebug') === '1'
}

export function getDebugGasPumpStatus () {
  return {
    pumpStatus: {
      // One row per status style — change values to preview pump-status-* CSS
      pStat: [0, 1, 3, 8],
      nameGas: ['95 E10', '98 E5', 'Diesel', 'AdBlue'],
      cNozzle: [0, 1, 0, 0],
      litre: [0, 0, 4523, 0],
      amount: [0, 0, 8135, 0],
      // Bits 4–7 mark POS-sourced pumps (affects status text for codes 1 and 3)
      flagFilling: (1 << 4) | (1 << 6),
      prices: [
        { price: [1899, 1999] },
        { price: [2099, 2199] },
        { price: [1799, 1849] },
        { price: [129, 135] }
      ]
    }
  }
}

export function getDebugGasPumpTransactions () {
  const now = new Date()
  return [
    {
      id: 101,
      date: now,
      pumpIndex: 2,
      gasType: 'Diesel',
      price: 1.799,
      litres: 45.23,
      source: '1',
      status: 0,
      pos: 1
    },
    {
      id: 102,
      date: new Date(now.getTime() - 3600000),
      pumpIndex: 0,
      gasType: '95 E10',
      price: 1.899,
      litres: 32.1,
      source: '0',
      status: 0,
      pos: 2
    },
    {
      id: 103,
      date: new Date(now.getTime() - 7200000),
      pumpIndex: 1,
      gasType: '98 E5',
      price: 2.099,
      litres: 28.5,
      source: '1',
      status: 0,
      pos: 1
    }
  ]
}

export function getDebugProcessedGasPumpTransactions () {
  return [
    {
      id: 201,
      date: new Date(Date.now() - 86400000),
      pumpIndex: 3,
      gasType: 'AdBlue',
      price: 0.129,
      litres: 12,
      source: '1',
      status: 1,
      pos: 1
    }
  ]
}
